import { useStore } from '@nanostores/react';
import { memo } from 'react';
import { QrDialog } from './qr-dialog';
import { useDevicePreview, closeDevicePreviewURL } from '~/lib/stores/device-preview';
import { themeStore } from '~/lib/stores/theme';

export const DevicePreviewDialog = memo(() => {
  const { open, url, count } = useDevicePreview();

  return (
    <QrDialog open={open && !!url} title="Device Preview" data={url} onClose={closeDevicePreviewURL}>
      <Logo />
      <h2 className="text-lg font-semibold leading-6">
        {count > 1 ? <>Scan code to reconnect to Expo</> : <>Preview on your own mobile device</>}
      </h2>
      <div className="flex flex-col gap-2 m-6 text-bolt-elements-textSecondary">
        <span>1. Install Expo Go</span>
        <div className="flex flex-col gap-6">
          <span>2. Scan this QR code</span>
          <small className="relative text-sm text-bolt-elements-textTertiary border border-bolt-elements-borderColor rounded-md px-4 py-2.5 bg-alpha-gray-2 dark:bg-alpha-white-5">
            Use the code scanner app on iOS or Expo Go on Android
          </small>
        </div>
      </div>
    </QrDialog>
  );
});

DevicePreviewDialog.displayName = 'DevicePreviewDialog';

function Logo() {
  const theme = useStore(themeStore);

  return (
    <div className="flex items-center justify-center mb-5">
      <svg width="114" height="32" viewBox="0 0 114 32">
        <path
          fill={theme === 'dark' ? '#FFF' : '#000'}
          d="M14.805 10.334c.256-.377.535-.425.762-.425.227 0 .605.048.86.425 2.015 2.766 5.34 8.277 7.791 12.342 1.6 2.65 2.828 4.687 3.08 4.946.946.972 2.243.366 2.997-.737.742-1.086.948-1.849.948-2.663 0-.554-10.752-20.552-11.835-22.217C18.366.405 18.028 0 16.245 0H14.91c-1.777 0-2.034.404-3.075 2.005C10.753 3.67 0 23.668 0 24.222c0 .814.206 1.577.948 2.663.754 1.103 2.052 1.71 2.998.737.252-.26 1.48-2.295 3.08-4.946 2.451-4.065 5.765-9.576 7.78-12.342Zm23.913-8.566v24.55h14.96v-4.98h-9.799v-5.19h8.718v-4.98h-8.718v-4.42h9.799v-4.98h-14.96Zm34.922 24.55-6.208-8.908 5.789-8.312h-5.859l-2.859 4.068-2.825-4.068H55.75l5.789 8.347-6.172 8.873h5.858l3.243-4.664 3.243 4.664h5.928ZM86.115 8.747c-2.37 0-4.22.982-5.405 2.77v-2.42h-4.916V32h4.916v-8.102c1.186 1.789 3.034 2.771 5.405 2.771 4.429 0 7.95-4.033 7.95-8.979 0-4.945-3.521-8.943-7.95-8.943ZM85 21.934c-2.407 0-4.29-1.824-4.29-4.244 0-2.384 1.883-4.243 4.29-4.243 2.37 0 4.289 1.894 4.289 4.244 0 2.384-1.918 4.243-4.29 4.243Zm19.791-13.187c-5.056 0-8.892 3.858-8.892 8.979 0 5.12 3.835 8.943 8.892 8.943 5.021 0 8.892-3.823 8.892-8.943 0-5.121-3.871-8.979-8.892-8.979Zm0 4.735c2.301 0 4.08 1.789 4.08 4.244 0 2.384-1.779 4.208-4.08 4.208-2.337 0-4.08-1.824-4.08-4.208 0-2.455 1.743-4.244 4.08-4.244Z"
        />
      </svg>
    </div>
  );
}
